import { useEffect } from "react";
import { getToken, messaging, VAPID_KEY } from ".";
import { isSupported } from "firebase/messaging";

export const useRequestNotificationPermission = () => {
    useEffect(() => {
        const requestPermission = async () => {
            const supported = await isSupported();
            if (
                !supported ||
                !("Notification" in window) ||
                !("serviceWorker" in navigator) ||
                !("PushManager" in window) ||
                !messaging
            ) {
                return;
            }

            try {
                const permission = await Notification.requestPermission();

                if (permission === "granted") {
                    await getToken(messaging, { vapidKey: VAPID_KEY });
                }
            } catch (err) {
                console.error("Permission denied or error:", err);
            }
        };

        requestPermission();
    }, []);
};
